const companyInfo = [
  { label: '社名', value: '株式会社テクノワークス' },
  { label: '代表者', value: '代表取締役　山田 太郎' },
  { label: '設立', value: '2005年（平成17年）4月' },
  { label: '所在地', value: '〒135-0062　東京都江東区東雲1丁目1番1号' },
  { label: '電話番号', value: '03-1234-5678', tel: 'tel:0312345678' },
  { label: '営業時間', value: '平日 8:00〜17:00' },
  { label: '定休日', value: '土曜・日曜・祝日' },
  {
    label: '建設業許可',
    value: '国土交通大臣許可（般-05）第XXXXX号\n電気工事業・管工事業・土木工事業',
  },
  { label: '対応エリア', value: '東京都・神奈川県・埼玉県・千葉県' },
  { label: '資本金', value: '1,000万円' },
];

const CompanySection = () => {
  return (
    <section id="company" className="w-full py-16 sm:py-20" style={{ backgroundColor: '#F5F7FA' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* セクションタイトル */}
        <div className="mb-12 text-center">
          <p className="text-xs font-semibold tracking-widest mb-2" style={{ color: '#2C5AA0', letterSpacing: '0.15em' }}>
            COMPANY PROFILE
          </p>
          <h2 className="text-2xl sm:text-3xl font-bold mb-3" style={{ color: '#1A1A1A' }}>
            会社概要・アクセス
          </h2>
          <div className="mx-auto" style={{ width: '48px', height: '2px', backgroundColor: '#2C5AA0' }}></div>
        </div>

        {/* コンテンツ：テーブル + 地図 */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          {/* 会社情報テーブル */}
          <div className="lg:col-span-3 bg-white rounded-lg border border-gray-200 overflow-hidden">
            <div className="px-5 py-4 border-b border-gray-100" style={{ backgroundColor: '#EEF2FA' }}>
              <h3 className="text-sm font-bold" style={{ color: '#2C5AA0' }}>
                <span className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-building-2-line text-sm"></i>
                  </div>
                  会社基本情報
                </span>
              </h3>
            </div>
            <div className="divide-y divide-gray-100">
              {companyInfo.map((item) => (
                <div key={item.label} className="flex px-5 py-3.5 gap-4">
                  <dt
                    className="text-xs font-semibold flex-shrink-0 pt-0.5"
                    style={{ color: '#666', minWidth: '88px' }}
                  >
                    {item.label}
                  </dt>
                  <dd className="text-sm leading-relaxed flex-1" style={{ color: '#1A1A1A' }}>
                    {item.tel ? (
                      <a
                        href={item.tel}
                        className="font-semibold hover:opacity-75 transition-opacity"
                        style={{ color: '#2C5AA0' }}
                      >
                        {item.value}
                      </a>
                    ) : (
                      <span style={{ whiteSpace: 'pre-line' }}>{item.value}</span>
                    )}
                  </dd>
                </div>
              ))}
            </div>
          </div>

          {/* Googleマップ */}
          <div className="lg:col-span-2 flex flex-col gap-4">
            <div className="bg-white rounded-lg border border-gray-200 overflow-hidden flex-1" style={{ minHeight: '320px' }}>
              <div className="px-5 py-4 border-b border-gray-100" style={{ backgroundColor: '#EEF2FA' }}>
                <h3 className="text-sm font-bold" style={{ color: '#2C5AA0' }}>
                  <span className="flex items-center gap-2">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-map-pin-2-line text-sm"></i>
                    </div>
                    アクセスマップ
                  </span>
                </h3>
              </div>
              <iframe
                title="株式会社テクノワークス アクセスマップ"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.7490879655615!2d139.8119576!3d35.6472!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601889d07fc200eb%3A0x8d4d9a7c3fc1f8e9!2z5p2x5Lqs6YO95rGf5p2x5Yy65p2x6KW_77yR5LiB55uu77yR!5e0!3m2!1sja!2sjp!4v1700000000000"
                width="100%"
                height="320"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full"
              ></iframe>
            </div>

            {/* 対応エリア */}
            <div className="bg-white rounded-lg border border-gray-200 p-5">
              <h3 className="text-sm font-bold mb-3 flex items-center gap-2" style={{ color: '#1A1A1A' }}>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-2-line text-sm" style={{ color: '#2C5AA0' }}></i>
                </div>
                主な対応エリア
              </h3>
              <div className="flex flex-wrap gap-1.5">
                {['東京都', '神奈川県', '埼玉県', '千葉県'].map((area) => (
                  <span
                    key={area}
                    className="text-xs px-2.5 py-1 rounded-full border"
                    style={{ borderColor: '#D0DBF0', color: '#2C5AA0', backgroundColor: '#EEF2FA' }}
                  >
                    {area}
                  </span>
                ))}
              </div>
              <p className="text-xs mt-3 leading-relaxed" style={{ color: '#888' }}>
                ※上記エリア外についてもご相談ください。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanySection;
